import { Exam, ParticipantAnswers, Survey } from '@core/types';
import { AppDispatch, startQuestionnaire } from '@online-webinar/store';

export const showSurveyOrExam = (
    dispatch: AppDispatch,
    survey: Survey | null,
    surveyAnswers: ParticipantAnswers | null,
    exam: Exam | null,
    examAnswers: ParticipantAnswers | null
) => {
    if (exam?.enabled === true && exam?.isValid === true) {
        setTimeout(() => dispatch(startQuestionnaire({ type: 'exam', questionnaire: exam, answers: examAnswers })), 50);
        return true;
    }

    if (survey?.enabled === true && survey?.isValid === true) {
        setTimeout(() => dispatch(startQuestionnaire({ type: 'survey', questionnaire: survey, answers: surveyAnswers })), 50);
        return true;
    }

    // No valid exam or survey, show nothing
    return false;
};

export const onExamClose = (dispatch: AppDispatch, type: 'survey' | 'exam', survey: Survey | null, surveyAnswers: ParticipantAnswers | null) => {
    if (type !== 'exam' || survey?.enabled !== true || survey?.isValid !== true) {
        return false;
    }

    // Add small timeout to displaying the survey, looks pretty ;)
    setTimeout(() => dispatch(startQuestionnaire({ type: 'survey', questionnaire: survey, answers: surveyAnswers })), 1000);
    return true;
};
